import {connect} from '@modifi/redux'

import CompanyConfirmationDialog from './CompanyConfirmationDialog'
import {aSaveDataFromConfirmation, selectSaveErrorMessage, aReset, selectSavePending} from './store'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: Record<string, any>) => ({
  errorMessage: selectSaveErrorMessage(state),
  savePending: selectSavePending(state),
})

const mapDispatchToProps = {
  saveWithExistingCompany: aSaveDataFromConfirmation,
  reset: aReset,
}

export const DIALOG_NAME = 'intermediary-shareholder/confirm-existing-company'
export default connect(mapStateToProps, mapDispatchToProps)(CompanyConfirmationDialog)
